"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthAPI = void 0;
const BaseAPI_1 = require("./BaseAPI");
class AuthAPI extends BaseAPI_1.BaseAPI {
    constructor(requester, onAuthenticated) {
        super(requester);
        this.onAuthenticated = onAuthenticated;
        this.path = 'auth';
    }
    createAccount(body) {
        return __awaiter(this, void 0, void 0, function* () {
            const user = yield this.requester.post(this.getEndpoint('create-account'), body);
            return user;
        });
    }
    signIn(body) {
        return __awaiter(this, void 0, void 0, function* () {
            const token = yield this.requester.post(this.getEndpoint('sign-in'), body);
            this.onAuthenticated(token);
            return token;
        });
    }
    signInAdmin(body) {
        return __awaiter(this, void 0, void 0, function* () {
            const token = yield this.requester.post(this.getEndpoint('sign-in', 'admin'), body);
            this.onAuthenticated(token);
            return token;
        });
    }
    refresh(body) {
        return __awaiter(this, void 0, void 0, function* () {
            const token = yield this.requester.post(this.getEndpoint("refresh"), body);
            this.onAuthenticated(token);
            return token;
        });
    }
    check() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.requester.get(this.getEndpoint("check"));
        });
    }
}
exports.AuthAPI = AuthAPI;
